<div class="">
  <div class="close-container">
    <img src="../assets/close_icon.svg" (click)="onClickClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClickClose()" (keydown.space)="$event.preventDefault(); onClickClose()">
  </div>
  <div class="container" style="margin-top: 30px;">
    <div class="flex">
      <div class="status-icon">
        <img *ngIf="data.stepSuccessful" src="../../assets/success_new.png" alt="Success">
        <img *ngIf="!data.stepSuccessful" src="../../assets/error.svg" alt="Error">
      </div>

    </div>
    <div class="status-content">
      <!-- <h2 class="status">{{data.title}}</h2> -->
      <p class="status-details text-sub-heading-color">{{data.details}}</p>
      <div *ngIf="data.descriptionHtml && data.descriptionHtml.length > 0" [innerHTML]="data.descriptionHtml | safeHtml"
        class="text-center-align"></div>
    </div>

    <div *ngIf="isWebView" class="action-btn-container flex wrap justify-content-center pt-custom">
      <button mat-flat-button class="edit-form-button standard-btn button-with-radius" (click)="onClickClose()">
        Close
      </button>
    </div>
    <div *ngIf="!isWebView" class="action-btn-container flex wrap justify-content-center pt-custom">
      <button mat-flat-button class="edit-form-button standard-btn button-right-no-radius" (click)="onClickClose()">
        Close
      </button>
    </div>
  </div>
</div>

<!-- <div>
  <div class="btn-container" *ngIf="data.stepSuccessful">
    <button *ngIf="data.redirectToUR" mat-stroked-button class="btn approve-btn btn-txt approve-text"
      (click)="onClickBackToMyGarage()">Back to MyGarage</button>
    <button *ngIf="!data.redirectToUR" mat-button class="danger-btn standard-btn"
      (click)="onClickClose()">Close</button>
  </div>

  <div class="btn-container" *ngIf="!data.stepSuccessful">
    <button mat-stroked-button class="btn approve-btn btn-txt approve-text" (click)="onClickClose()">Try Again</button>
  </div>
</div> -->
